import { useLoginStore } from '@/login/stores/useLoginStore';
import type { Collection } from '@/newApi/services/ResgateManager';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import type { EmploymentSalaryType } from '@sysarb/sysarb-types/general/enums';
import type { QueryOptions } from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

type InvolveSalaryTypesOptions = {
    queries: {
        getInvolveSalaryTypes: (employmentId: string | null) => QueryOptions<Collection<EmploymentSalaryType> | null, Error, EmploymentSalaryType[]>;
    };
};

export const involveSalaryTypes: InvolveSalaryTypesOptions = {
    queries: {
        getInvolveSalaryTypes: (employmentId: string | null): QueryOptions<Collection<EmploymentSalaryType> | null, Error, EmploymentSalaryType[]> => {
            const { instanceTopic } = useLoginStore();
            const topic = `v1.${instanceTopic}.base-register.employment.${employmentId}.involve-salary-types`;

            return queryOptions<Collection<EmploymentSalaryType> | null, Error, EmploymentSalaryType[]>({
                meta: {
                    subscribe: true,
                    type: 'resgate',
                    resourceId: topic,
                },
                queryKey: ['section-manager', 'involve-salary-types', topic],
                queryFn: async (): Promise<Collection<EmploymentSalaryType> | null> => {
                    const resgate = ResgateManager.getInstance();
                    const res = await resgate.collection<EmploymentSalaryType>(topic);
                    if (res instanceof ResErr) throw new Error(res.message);
                    return res;
                },
                select: data => data?.list ?? [],
                enabled: () => employmentId != null,
            });
        },
    },
};
